import { Model, Shared_model_info } from "../interfaces";

export const modelRemappingFromResult = (data: any) => {
  /* console.log(data); */
  let finalObj: any = {
    id: data.bio?.id,
    bio: {
      name: data.bio?.name,
      surname: data.bio?.surname,
      birth_date: data.bio?.birth_date,
      nationality: data.bio?.nationality,
      place: data.bio?.place,
    },
    measures: {
      height: data.measures?.height,
      bust: data.measures?.bust,
      hips: data.measures?.hips,
      waist: data.measures?.waist,
      shoes: data.measures?.shoes,
      eyes: data.measures?.eyes,
      hair: data.measures?.hair,
    },
    contacts: {
      agency: data.contacts?.agency,
      phone: data.contacts?.phone,
      mail: data.contacts?.mail,
      socials: {
        instagram: {
          link: data.instagram?.link,
          followers: data.instagram?.followers,
        },
        facebook: {
          link: data.facebook?.link,
          followers: data.facebook?.followers,
        },
        tiktok: { link: data.tiktok?.link, followers: data.tiktok?.followers },
      },
    },
    portfolio: {
      photos: data?.photos,
      polaroids: data?.polaroids,
      videos: data?.videos,
      documents: data?.documents,
    },
    proposal: {
      proposed_times: data?.proposed_times,
      approved_times: data?.approved_times /* , trend: number */,
    },
    work_categories: {
      catalog: data.work_categories?.catalog,
      look_book: data.work_categories?.look_book,
      campaign: data.work_categories?.campaign,
      editorial: data.work_categories?.editorial,
      show: data.work_categories?.show,
      showroom: data.work_categories?.showroom,
      digital: data.work_categories?.digital,
      tv_commercial: data.work_categories?.tv_commercial,
    },
    profileImageSrc: data?.profileImageSrc,
    lookbook: data?.lookbook,
    composite: data?.composite,
    /* skills mvp 2 */
    /* skills: {
      driver_license: data?.driver_license,
      swim: data?.swim,
      ride_bicycle: data?.ride_bicycle,
      ski: data?.ski,
      ride_horse: data?.ride_horse,
      diving: data?.diving,
    } */
    /*  */
  };
  /*  console.log(finalObj); */
  return finalObj;
};

export const modelRemappingFromEditInputs = (
  data: any,
  profileImage?: any[],
  photos?: any[],
  polaroids?: any[],
  videos?: any[],
  documents?: any[]
) => {
  let finalObj: any = {
    name: data?.name,
    surname: data?.surname,
    birth_date: data?.birth_date,
    nationality: data?.nationality,
    place: data?.place,
    height: data?.height,
    bust: data?.bust,
    hips: data?.hips,
    waist: data?.waist,
    shoes: data?.shoes,
    eyes: data?.eyes,
    hair: data?.hair,
    agency: data?.agency,
    phone: data?.phone,
    mail: data?.mail,
    instagram: {
      link: data?.instagram,
    },
    facebook: {
      link: data?.facebook,
    },
    tiktok: {
      link: data?.tiktok,
    },
    photos: photos,
    polaroids: polaroids,
    videos: videos,
    documents: documents,
    profileImageSrc: profileImage,
    /* skills mvp 2 */
    /* driver_license: data.driver_license,
    swim: data.swim,
    ride_bicycle: data.ride_bicycle,
    ski: data.ski,
    ride_horse: data.ride_horse,
    diving: data.diving, */
    /*  */
  };
  return finalObj;
};

export const modelsRemappingFromSharedResponse = (data: any[]) => {
  const finalArray: any[] = [];
  data.forEach((item: Shared_model_info) => {
    const remappedModel = {
      bio: {
        name: item.name,
        surname: item.surname,
      },
      measures: {
        height: item.height,
        bust: item.bust,
        waist: item.waist,
        hips: item.hips,
      },
      profileImageSrc: item.profileImageSrc,
      composite: item?.composite,
      lookbook: item?.lookbook,
    };
    finalArray.push(remappedModel);
  });
  return finalArray;
};
